import apiService from "../../../Services/APIService";

/**
 * Send OTP to admin email for reset data verification
 * @param {string} adminEmail - Admin user's email address
 */
export const sendResetOTPAPI = async () => {
    try {
        const payload = {
            changeType: "RESETOTP"
        };
        const result = await apiService.sendChange(11, "reset", payload);
        return result;
    } catch (error) {
        console.error('Error sending reset OTP:', error);
        throw error;
    }
};

/**
 * Reset agency data after OTP verification
 * @param {string} otp - OTP received via email
 */
export const resetAgencyDataAPI = async (otp) => {
    try {
        const payload = {
            changeType: "RESETFULL",
            otp: otp
        };
        const result = await apiService.sendChange(11, "reset", payload);
        return result;
    } catch (error) {
        console.error('Error resetting agency data:', error);
        throw error;
    }
};

export const verifyResetOTP = async (otp) => {
	    try {
        const payload = {
            changeType: "VERIFYRESETOTP",
            otp: otp
        };
        const result = await apiService.sendChange(11, "reset", payload);
        return result;
    } catch (error) {
        console.error('Error resetting agency data:', error);
        throw error;
    }
}
